export const LOADER_APPROACHES             =    'LOADER_APPROACHES';
export const GET_APPROACHES                =    'GET_APPROACHES';
export const APPROACHES_FAIL               =    'APPROACHES_FAIL';
export const SAVE_LOADER_APPROACHES        =    'SAVE_LOADER_APPROACHES';
export const FORM_APPROACHES_FAIL          =    'FORM_APPROACHES_FAIL';

